export const locale = {
  lang: "en",
  data: {
    Global: {
      rTicket: "Ticket search",
      ncs: "No special characters allowed",
      vSuj: "Please choose a topic",
      rec: "Claim",
      di: "Information request",
      rem: "Thanks",
      av: "Opinion",
      success: "success",
      info: "Information",
      err: "Error",
      tousS: "All services",
      tnd: "Tunisian Dinar (TND)",
      bonus: "Bonus",
      dt: " TD",
      boutonpd: "More Details",
      opp: "Portability operator",
      oo: "Ooredoo",
      tt: "Tunisie Telecom",
      or: "Orange",
      valider: "Confirm",
      org: "Organism",
      ref: "Reference",
      montant: "Amount",
      mp: "Amount paid",
      env: "Send",
      max: "Maximum",
      conf: "Confirmer",
      renv: "Resend",
      ann: "Cancel",
      retourcnx: "Back to the login page",
      retour: "Return",
      continuer: "Continue",
      passer: "Skip this step",
      suiv: "Next",
      payer: "Payer",
      rp: "Payment receipt",
      rt: "Transaction receipt",
      pnv: "Pay with a new card",
      mdp: "Payment Method",
      date: "Date",
      it: "Transaction ID",
      dateOp: "Operation Date",
      etat: "Status",
      ea: "En attente",
      bonusg: "Bonus Earned",
      pfc: "Loyalty points collected",
      sold: "Balance",
      msg: "SPW appreciates your loyalty and rewards you for your purchases",
      astuce: "SPW Tip!",
      rEmailActif: "Make primary",
      supportADisposition:
        "Our customer support team is available to assist you whenever you need help or have any questions.",
      desWallet1:
        "The Wallet functions as your digital purse, allowing you to effortlessly manage your SPW account balance online.",
      desWallet2:
        "Seamlessly send and receive money, and conveniently pay for various services using the SPW Wallet.",
      pts: "points",
      confirm: "Confirmation",
      confdemande: "Confirm your request",
      resOp: "Transaction result",
      vRes: "See the result",
      choixMP: "Choose a payment method",
      addBenf: "Beneficiary addition",
      avis: "Share your opinion",
      wlc: "You are well connected to SPW  🎉 , 👋 Welcome",
      tapmsg: "Please type your message",
      pin: "PIN successfully added",
      msgcode: "Please enter at least one code or skip this step",
      mconf: "👋 You have already confirmed your Email ",
      tconf: "👋 You have already confirmed your Phone",
      imgmsg: "We accept extensions (jpg, png and jpeg) and the size must be less than 5MO",
      paymsg: "You can’t pay with this card",
      wallmsg: "You can’t pay with the Wallet",
      editmsg: "modification has been successfully changed",
      gcb: "This card is deleted",
      rib: "The RIB does not correspond to any bank, please check",
      editben: "Beneficiary is successfully modified",
      tranmsg: "Enter the number and amount",
      max50: "The maximum amount is 50 DT",
      numinv: "Invalid phone number",
      wallins: "Your Wallet balance is insufficient",
      fav: "Manage the display of your favorite services on the homepage by clicking on the star",
      notif: "Notifications",
      notif2: "Unread",
      notif3: "View All",
      notif4: "No notifications found",
      param: "Settings",
      faq: "FAQ",
      deco: "Logout",
      cb: "Bank account",
      paym: "Merchant Payment",
      wsf: "SPW Wallet",
      aw: "Top Up Wallet Via",
      cp: "Payment Card",
      vv: "Deposit/Transfer",
      rev: "Reseller",
      pre: "Previous",
      dastuce: "Would you like to save this card for easier, faster, and secure payment next time?",
      pm: "Not now",
      enr: "Save",
      frais: "Fees",
      transuc: "The transaction has been correctly processed",
      lcom: "Leave a Comment",
      com: "Comment",
      noter: "Rate",
      sms: "SMS",
      codeenv: "Enter the code sent to",
      codeenva: "Code sent to",
      codeenvnum: "Code sent to the number",
      codee: "Enter the code sent to your",
      mvs: "Movements of the Credit Balance",
      dd: "Start Date",
      df: "End Date",
      nomv: "No movement on your credit balance",
      merci: "Thank you for your purchase",
      ta: "Transfer money",
      rbank: "Bank Identity Statement",
      nvs: "New Balance",
      infoB1: "You benefit from a SPW Bonus after the purchase of any service on our platform",
      infoB2:
        "The amount of this bonus is added to your SPW Bonus balance immediately after payment confirmation.",
      infoB3:
        "You can then transfer your Bonus balance to your Credit balance and enjoy all available services.",
      infoAvoir:
        "The Credit Balance represents the amount paid following a refund, compensation, or other reasons. It then allows you to pay for the services offered by SPW",
    },
    Dash: {
      title1: "My Wallet",
      stnd: "TND Balance",
      da: "Last refill",
      dt: "Last Transfer",
      alim: "Top Up",
      tran: "Transfer",
      tiktak: "Tik Tak",
      dTiktak: "Buy quickly in two clicks with our new TIK TAK service",
      boutonTiktak: "Discover",
      titletran: "Transactions",
      dTran: "My last transactions",
      sfid: "Loyalty program",
      dtbonus: "Bonus Earned",
      tsoldeavoir: "Transfer to Avail Balance",
      soldeav: "Credit balance",
      titlequick: "Transfer money to another SPW wallet",
      titlequick2: "Add Beneficiaries",
      demwallet: "Request a Wallet",
      as: "Buy on SPW",
      std: "standard",
      pf: "Collected points",
      messolde: "My Balances",
      suivisolde: "Balance History",
      sa: "Current status",
      qt1: "The daily service purchase quota is",
      qt2: "DT per day",
      gservF: "Manage your favorite services",
      notif: "Notifications",
      sc: "Customer Support",
      trB: "Transfer Bonus to Balance",
    },
    tiktak: {
      tiktak: "Tik Tak",
      title: "Payment is made directly with the balance of your SPW Wallet: Click PAY.",
      title1: "Telephone charging by direct transfer",
      title2: "Telephone charging by charging card",
      title3: "Payment of invoices",
      msg1: "You are about to make a direct transfer of",
      msg2: "DT to the number",
      payer: "Payer",
      recu: "recu",
      rautre: "Recharge another number",
      msg3: "Success of the operation",
      msg4: "Click on the receipt to view your recharge code",
      msg5: "You are about to purchase a mobile recharge card",
      msg6: "of value",
      tdtitle: "Quick Transfer",
      msg7: "Successful mobile recharge operation",
    },
    verf: {
      title:
        "Proceed to the confirmation of your email address and phone number to verify your account",
      confM: "Confirm my Email",
      confM2: "Email Confirmed",
      confT: "Validate my phone",
      confT2: "Phone Validated",
      verCompte: "Check my account",
      d1: "Enter the received code on",
      contenu1: "Edit my email",
      contenu2: "New phone number",
      desVer: "Check my account and create my first wallet",
      des: "Verify your identity and enjoy unlimited access to all services on SPW",
      cj: "Cash-In/Day",
      mcj: "Maximum Cashout/Day",
      ocj: "Operation Cash-In/Day",
      o: "Operations",
      mocj: "Maximum Operation Cashout/Day",
      sw: "Wallet Balance",
      v: "Verified",
      enc: "In Progress",
      rf: "Fill out the online form",
      oui: "Yes",
      non: "No",
    },
    control: {
      champobli: "Mandatory field ",
      min6: "Minimum 6!",
      min6c: "Minimum 6 characters",
      max16: "Maximum 16!",
      invFormat: "Incorrect format!",
      min2: "Minimum 2!",
      max2: "Maximum 2!",
      montantinc: "incorrect amount",
      mailob: "Email is mandatory",
      mailv: "Enter a correct email address",
      codeinc: "incorrect code",
      numinv: "Invalid number",
      piniden: "Two non-identical pins	PIN codes must be identical",
      patterPrenom: "Please enter a valid first name",
      patterNom: "Please enter a valid name",
      mdp: "Your password must be at least 8 characters long (a set of numbers and letters and at least one letter capital letter and lowercase)",
      mdpinv: "invalid password",
      mdpidn: "Passwords must be identical",
      mode: "Choose how to send the code",
      nomval: "Please enter a valid name",
      pin6: "The PIN is 6 digits",
      pininc: "PIN incorrect",
      max: "Montant maximum",
      min1dt: "Minimum 1 DT",
      min10dt: "Minimum 10 DT",
      dd: "Start date is mandatory",
      df: "End date is mandatory",
      opob: "Type of operation is mandatory",
      rib: "RIB is 20 digits",
      min4: "Minimum 4 characters",
      min: "minimum",
      maxi: "maximum",
      inv: "invalid",
      dfsup: "End date must be greater than start date!",
      top: "Type of Operation",
      cinv: "Code association invalide",
      c100m: "100 caractères maximum",
      mmin: "Minimum Amount",
    },
    placeholder: {
      numtel: "Phone number",
      mont: "Amount",
      numver: "Transfer Number",
      trVV: "Download the payment/transfer receipt",
      idw: "ID Wallet/Email of the beneficiary",
      motiftran: "Transfer Reason",
      motiftran2: "Leave a message for the recipient.",
      rib: "Bank Account Number (RIB)",
      bank: "Bank",
      searchfav: "Favorite search",
      numfav: "Phone number",
      search: "Search",
      cm: "Code marchand",
      etq: "Etiquette",
      nmail: "New Email",
      cP: "SMS code",
      cM: "E-mail code",
      mP: "Modify phone",
      davis:
        "Your opinion matters to us. Do not hesitate to send a recommendation, an opinion, a remark, etc",
    },
    Connexion: {
      welcome: "Welcome to SPW",
      msg1: "Log in to your account",
      dPIN2: "Your security is our priority; enter your PIN",
      msg3: "New to SPW?",
      msg4: "Create an account",
      pin: "PIN",
      pinoub: "Forgot PIN?",
      cnx: "Log In",
    },
    Inscri: {
      title: "The adventure begins here",
      title2: "Registering for SPW is fast and free.",
      dPIN: "For your security, set a PIN",
      errmsg1: "You already have an account on SPW with this email address.",
      errmsg2: "This email is already in use.",
      title4: "Already have an account?",
      title5: "Log in",
      title6: "or register with",
      confpin: "PIN Configuration",
      condi: "Terms of Use",
      condi2: "Privacy Policy",
      et: "and",
      condi3: "Refund Policy",
      condi4: "of SPW",
      ng: "Manager's Name",
      pg: "Manager's First Name",
      nummob: "Mobile Phone Number",
      numfix: "Landline Phone Number",
      ns: "Company Name",
      sd: "Business Sector",
      fj: "Legal Form",
      pp: "Individual",
      sarl: "Limited Liability Company",
      sa: "Limited Company",
      suarl: "Single Member Limited Liability Company",
      numi: "Identity number",
      numiinv: "Invalid identity number",
    },
    forgotPass: {
      rPW: "Password reset",
      descMP: "Enter the email address and phone number associated with your SPW account",
      dPW: "Set your new password",
    },
    ResetPin: {
      rPIN: "PIN reset",
      dPIN3: "Set your new PIN",
    },
    Browsec: {
      sauv: "Save the browser",
      title: "Identity Verification",
      title1: "To access your account securely, we want to verify your identity",
    },
    vPIN: {
      title: "PIN",
      des: "",
    },
    Carte: {
      alimCarte: "Card Recharge",
      dAlimCarte: "Choose the amount and card",
      Conf: "Confirmation",
      RS: "Transaction Result",
      D1: "Recharge your SPW wallet securely and conveniently online.",
      desAlim:
        "Enter the amount, choose the card that suits you, validate the payment, and your SPW wallet is recharged immediately",
      aw: "Wallet Recharge",
      rw: "Wallet Refill",
      numver: "Deposit/Transfer Number",
      numc: "Account Number",
    },
    Espece: {
      title1: "Reload wallet by Payment/Transfer",
      title2: "List of agencies",
      AE: "Cash Wallet Recharge",
      DAC: "Fill in the form",
      Conf: "Confirmation",
      RS: "Transaction Result",
      D1: "Tailored for those without an online payment card.",
      D2: "You can add funds to your SPW wallet by making a cash payment or transfer through our partner bank branches or the nearest post office.",
    },
    popRes: {
      title: "You are not authorized!",
      des: "",
      title2: "Verifier",
    },
    AccountSet: {
      title: "Personal Information",
      bouton: "Modify",
      des: "Allowed JPG, GIF or PNG. Max size of 800kB",
      pmcp: "Account Settings",
      vw: "Verification and Wallet",
      nom: "Name",
      prenom: "First Name",
      dn: "Date of Birth",
      ville: "City",
      modifmdp: "Change Password",
      modifpin: "Change PIN",
      modifmail: "Change Email",
      hismail: "Email History",
      vpin: "Verify PIN with Every Transaction",
      cc: "Close Account",
      ancienpass: "Old Password",
      vpass: "New Password",
      cpass: "Confirm Password",
      ancienpin: "Old PIN",
      vmpin: "New PIN",
      cpin: "Confirm PIN",
      ancientel: "Old Phone Number",
      vtel: "New Phone Number",
      mdp: "Password",
      numide: "Numbers must be non-identical",
      scode: "SCode",
      mdpoub: "Forgot Password?",
      ancienm: "Old Email",
      hemail: "Email Change History",
      email: "Email",
      du: "Usage Date",
      dm: "Modification Date",
      vk: "Provide the missing information via this form to have an SPW Wallet",
    },
    Rev: {
      title:
        "Recharge your SPW Wallet at SPW resellers. Go to the nearest shop, deposit cash for an instant recharge.",
      rev: "Resellers",
      search: "Reseller Search",
    },
    CashOut: {
      title1: "Instant and secure money transfer to a SPW Wallet.",
      wFav: "Favorite beneficiary wallets",
      tw: "Money Transfer to Wallet",
      dtw: "Fill in the form",
      tvw: "Transfer to Wallet",
      d1: "With my wallet, I can effortlessly send money to another SPW wallet instantly, no matter where I am or what time it is.",
      d2: "Complete the form, verify the transfer transaction, and instantly top up the wallet of your recipient.",
      dwf: "An easier money transfer! Add your loved ones' wallets to your favorite list",
      title3: "Money Transfer to a Bank Account",
      title4: "My Bank Accounts",
      d3: "Money transfer request",
      d4: "We are dedicated to providing you with a secure and guaranteed money transfer to your bank account. Your financial transactions are protected and ensured for peace of mind.",
      mcb: "Manage Bank Accounts",
      addrib: "Please add a bank account number (RIB) to make a bank transfer",
      conftran: "Confirm money transfer",
      addBenf1: "Add a beneficiary to the favorite list",
      nombenf: "Beneficiary name",
      confdem: "Confirm transfer request",
      addRIB: "Addition of a bank account",
      desAddR2: "Enter the RIB and download the bank identifier",
      dmen: "Money Transfer Request",
      vb: "Bank Transfer",
      dd: "Request Date",
      nbenf: "Beneficiary name",
      rbenf: "Beneficiary RIB",
      mwall: "Edit a Beneficiary",
      nomben: "Beneficiary's Name",
      vnomben: "Please enter a valid beneficiary name",
      img: "image",
      title2: "Choose the balance you want to transfer from",
    },
    RechTel: {
      d1: "Experience a hassle-free and rewarding mobile recharge with SPW.",
      d2: "Enter the phone number and desired amount, make a secure payment, and your mobile line will be instantly recharged.",
      gmf: "Manage My Favorites",
      d4: "Select the desired amount for your top-up card and choose your mobile operator. Proceed with a secure payment and instantly receive your recharge code",
      cr: "Payment receipt",
      msg: "SPW appreciates your loyalty and rewards you for your purchases",
      rn: "Reload again",
      codeRech: "Reload code",
      addFav: "Add to favorites list",
      gFav: "Manage your favorite numbers",
      daddFav: "Add your loved ones' numbers to your favorites for a faster recharge",
      td: "Direct transfer",
      vcr: "Your Recharge Code",
      v: "Value",
      adfav: "Add a favorite number",
      imgfav: "Image favoris",
      add: "Add",
      edfav: "Edit favorite number",
      num8: "8-digit number",
      numTel: "Telephone number",
    },
    Marchand: {
      DES1: "Pay securely at partner merchants via your SPW account and benefit from bonuses and promotions. Discover the list of the best merchants who accept SPW as a means of payment.",
      DES2: "Discover the list of the best merchants who accept SPW as a means of payment",
      DES3: "Here we go! Secure and rewarded payment at partners with SPW.",
      DES4: "Shop and pay safely.",
      DES5: "Need assistance? Please contact our support department.",
      dcc: "On the websites of our partner dealers, once you have ordered a good or service by choosing to track payment with SPW, an online payment code is generated to identify your order; it is the Order Code.",
      T1: "Paiement marchand",
      DT1: "Enter the order code",
      DT3: "Confirm your purchase and pay",
      T4: "Transaction Result",
      DT4: "View Purchase Result",
      Contenu1: "Order Code",
      Contenu2: "Pay via order code",
      BS: "Next",
      BV: "Verify",
      BR: "Return",
      ChampOb: "Champ obligatoire",
      Contenu3: "This code remains valid only",
      Contenu4: "minute",
      Contenu5: "Transaction Details",
      Contenu6: "Merchant Name",
      Contenu7: "Merchant Website",
      Contenu8: "Amount",
      Contenu9: "Bonus",
      Contenu10: "Transaction Date",
      DEXP: "EXPIRY DATE",
      PNV: "Pay with a new card",
      POSTEinfo1: "E-Dinar Smart, Digicard",
      POSTEDinfo1: "Utilisez votre carte prépayée de la Poste",
      POSTEinfo2: "Visa Electron, DinarPost",
      POSTEDinfo2: "Utilisez votre carte Visa Electron ou DinarPost de la poste",
      invFormat: "Incorrect format!",
      DES6: "A gift, a life! Open your heart for an association by making a donation online with SPW. Just click on the association and follow the instructions.",
      DES7: "Without an e-commerce site, pay at physical, virtual, social, freelance, etc., stores with the Merchant Code, the Merchant ID on the SPW platform.",
      dT1: "Make a donation",
      dDT1: "Choose an association",
      dDT3: "Confirm your purchase and pay",
      dT4: "Transaction Result",
      dDT4: "View Purchase Result ",
      dContenu1: "Make a donation",
      dContenu2: "Choose an association",
      cmT1: "Paiement marchand",
      cmDT1: "Enter the merchant code",
      cmDT3: "Confirm your purchase and pay",
      cmT4: "Transaction Result",
      cmDT4: "View Purchase Result",
      cmContenu1: "Paiement marchand",
      cmContenu2: "Enter the merchant code",
      rsite: "Return to the merchant website",
      pc: "Pay via Merchant Code",
      cmd: "Order",
      mp: "Partner Merchants",
    },
    fid: {
      title: "Your loyalty is rewarded.",
      subtitle: "Our loyalty program is the ultimate way to express our gratitude!",
      subtitle2:
        "Accumulate points with each purchase, unlock rewards, and enjoy the benefits of our loyalty program",
      d1: "Progress from one status to the next and unlock greater rewards and benefits along the way.",
      d2: "Enjoy with SPW, your purchases are rewarded.",
      pd: "More details about the loyalty program.",
      sValide: "Validated status",
      sActuel: "Current status",
      sSuivant: "Next status",
      sVerouille: "Locked status",
      fid7: "Our loyalty program is the ultimate way to show our gratitude!",
      fid8: "To reward your loyalty, SPW offers you cumulative loyalty points on each purchase, allowing you to progress in the status, and therefore the benefits and rewards evolve with each pass",
      sysProg: "Progression system",
      prog1:
        "We offer 5 loyalty statuses: Standard, Silver, Gold, Diamond, and VIP. Below are the rules for moving from one status to another.",
      prog2:
        "To unlock a Status, you need to collect a specific number of points within a well-defined date range.",
      nbPoints: "Nombre Number of points to collect",
      intervalleDate: "Date range in days",
      sysCollecte: "Point collection system",
      coll1:
        "After your purchases, you can accumulate points quickly by following the scale below.",
      valUni: "Unit value in DT",
      ptsaG: "Points that can be earned",
      sysRec: "Reward system",
      sysRec1: "Different ways to reward your loyalty; different ways to say thank you!",
      sysRecul: "Recoil system",
      sysRecul1:
        "Can I lose my points or even my status? Unfortunately, it is possible. Stay faithful, and you will lose nothing.",
    },
    mdp: {
      cr: "Charging board",
      sc: "Select a card",
      mdp: "Payment Method",
      cp: "Confirmation and payment",
      cap: "Confirm your purchase and pay",
      ro: "Transaction Result",
      vro: "View Purchase Result",
      op: "Operation",
      tvcb: "Transfer to a Bank Account",
      Conf: "Confirmation",
      r: "Result",
      ra: "Purchase Result",
    },
    recu: {
      srv: "Service",
      scr: "Telephone charging by card",
      ds: "Service Details",
      op: "Operator",
      md: "Requested Amount",
      com: "Commission",
      bonus: "Bonus",
      pf: "loyalty points",
      tap: "Total to Pay",
      rem: "Remise",
      nm: "Merchant Name",
      sm: "Merchant Website",
      p: "pts",
      map: "Amount to Pay",
      ns: "Serial Number",
      dt: "Transaction Details",
      tsw: "Transfer balance to wallet",
      mexp: "Sender's Email",
      mrec: "Recipient's Email",
      dp: "Payment Date",
      numCpt: "Account number",
      portC: "Account holder",
      fraisInt: "International fees",
      nomP: "Partner name",
      codeP: "Payment code",
      numCarte: "Card number",
      refPaie: "Payment reference",
      idwBene: "Beneficiary Wallet ID",
      numR: "Number recharged",
    },
    faq: {
      title: "We are here to help you!",
      subtitle: "Choosing a category will help you find answers faster and easier",
      search: "Recherche",
      aucres: "No results found",
      title2: "Do you have other questions?",
      subtitle2:
        "Feel free to contact us if you have any questions. We are always happy to help you",
      box1: "Contact Customer Support",
      box2: "Phone",
      box3: "Email",
      box4: "Address",
      box5: "Working Hours",
      resoc: "Our Social Networks",
      j1: "Monday - Friday",
      j2: "Saturday",
    },
    conso: {
      title: "Consumption",
      display: "Display",
      cw: "Cash In Wallet",
      ea: "Expand All",
      ca: "Collapse All",
      caw: "Cash Out Wallet",
      ssf: "SPW Services",
      pdc: "No consumption during this period",
      totalRc: "Total wallet credit operations",
      totalTr: "Total money transfer operations from the wallet",
      totalSer: "Total services purchased on SPW market",
      dont: "of which",
    },
    DocCarteRech: {
      cr1: "Recharge your phone credit using a top-up card",
      cr2: "Experience the convenience of our daily services with just a few clicks, and unlock bonuses and loyalty points with every transaction",
      cr3: "To purchase a refill code, please follow these steps",
      cr4: "Please make a selection of your operator and indicate the desired value for your refill code",
      cr5: "Choose the payment method that suits you and validate",
      cr6: "Upon completing the payment, the recharge code will be instantly provided to you",
      cr7: "Click on the«Recharge code»option and utilize the received code to replenish your balance",
      cr8: "To reload the code on your mobile device, follow these steps",
      cr9: "*101*Recharge code#",
      cr10: "*100*Recharge code#",
      cr11: "*123*Recharge code#",
      infoService: "Information service",
      fiscal:
        "The increase in the price of the recharge card is due to the tax stamp duty imposed by Tunisian law",
      crPerdu:
        "If you have misplaced your recharge code or if the payment page is not visible, you can access your transaction history and find your ticket under the «My Transactions» section",
    },
    DocRechTel: {
      td1: "Easily recharge your telephone line through direct transfer.",
      td2: "Indulge in our wide range of daily services with just a few clicks, and unlock exciting bonuses and loyalty points with every transaction.",
      td3: "Follow the instructions below to top up your balance",
      td4: "Enter your phone number and the desired amount for the recharge",
      td5: "Choose the payment method that suits you and validate",
      td6: "The amount you requested will be transferred to your phone line immediately after payment",
      td7: "For Ooredoo Light, TTcash, and Orange Express refills, a 14% deduction will be applied from the charged amount to cover the tax stamp fee.",
      td8: "The operator will send an SMS to the recipient confirming the successful reload operation.",
    },
    DocEspece: {
      cashInEspHeader: "Funding your SPW cash wallet through payment/transfer",
      cashInEsp1:
        "By using the payment/transfer method, you can easily add funds to your SPW balance and conveniently make multiple purchase transactions without needing a credit card or prepaid card from the post office.",
      cashInEsp2:
        "Follow the instructions below to recharge your wallet through a payment/transfer",
      cashInEsp3: "Visit any of our partnered bank branches or the nearest post office.",
      cashInEsp4: "Deposit the amount you want to use on SPW to HAMTEL’s account.",
      cashInEsp5:
        "Once the deposit is complete, you will receive a receipt containing a unique remittance number.",
      cashInEsp6:
        "Go to the 'Cash Wallet Feed' section on SPW.tn and carefully complete the application form with accurate information.",
      cashInEsp7:
        "Once our administrators review and approve your request, your SPW account will be promptly credited with the requested amount.",
    },
    DocWallet: {
      interw1:
        "Easily send or receive money to/from a loved one's SPW Wallet instantly, securely, and without any extra cost. The recipient must be registered on SPW.tn to avail of this service.",
      interw2: "To reload another wallet on SPW, simply follow these steps",
      interw3: "Enter the beneficiary's ID Wallet or Email along with the desired transfer amount.",
      interw4: "Add a personalized message for your recipient, if desired.",
      interw5: "Confirm the transaction, and the recipient's wallet will be instantly credited.",
      interw6:
        "Simplify your navigation with SPW by adding your loved ones' wallets as favorites. This way, you won't need to search for their email or wallet ID every time you make a transfer.",
    },
    en: {
      title: "English",
    },
    fr: {
      title: "French",
    },
    ar: {
      title: "Arabic",
    },
    da: {
      title: "Dialect",
    },
    trans: {
      title: "My Transactions",
      search: "Search Transactions",
      idt: "ID-Transaction",
      det: "Details",
      auctran: "No transactions found",
    },
    supp: {
      title: "Would you like to close this tikcet?",
      txt: "If you confirm this operation, the ticket will be permanently closed",
      btn1: "Yes, I confirm",
      btn2: "Cancel",
      nt: "New Ticket",
      t: "Tickets",
      tn: "Ticket n°",
      not: "No Tickets Created",
      mr: "My Claims",
      vm: "Your Message",
      af: "Add a File",
      fr: "Close Claim",
    },
    marchext: {
      title: "Enter your information to track the payment",
      it: "Transaction Information",
      dt: "Transaction Date",
      bsf: "SPW Bonus",
      adv: "What are the advantages of paying with SPW?",
      paysf: "Why pay through a SPW account!",
      db: "Bonuses",
      sr: "Refund System",
      sd: "Dedicated Support",
      mvf: "Thank you for your loyalty",
      vcc: "Your Order Code",
      att: "Attention, the code is valid for only",
      prg: "You can use the order code to complete the payment process or give the code to one of your close ones to make the payment on your behalf",
      pexp: "Express Payment",
      sp: "Payment Success",
      inscsf: "Sign up on SPW",
      cn: "Log In",
      p1: "Your payment has been successfully made to the merchant",
      rec: "Please find your receipt below",
      fq: "Simplify your daily life with SPW",
      rt: "Mobile Recharge",
      ta: "Money Transfer",
      dsf: "Discover SPW",
      sc: "Customer Service",
    },
    bloc: {
      title: "Request for Justification",
      dtitle: "Your SPW account is temporarily blocked",
      d1: "Front view of ID card",
      d2: "Front view of ID card with face",
      cimg: "Choose an image",
      d3: "ID card or passport with your face",
      d4: "ID card or passport with your face",
      d5: "Bank statement",
      d6: "Front view of the bank card",
      title2: "Phone Verification",
      dtitle2: "Please enter the validation code you received via SMS",
      sno: "Unauthorized service",
      dsno: "Proceed with the verification of your account to avail this service",
      dsno2:
        "Proceed with the confirmation of your account via your homepage to avail this service",
    },
    qt: {
      title: "Money transfer to another SPW Wallet",
      p1: "You are about to transfer",
      p2: "from your wallet to the wallet of",
      id: "ID",
      p3: "Once you confirm, the amount will be debited directly from your SPW wallet",
      vt: "Confirm the transfer",
      p4: "The transfer of",
      p5: "has been successfully transferred to the beneficiary's Wallet",
    },
    cloture: {
      title: "Close your SPW account and delete your data",
      p1: "If you need assistance before permanently closing your SPW account, please contact us through the following link",
      nc: "Contact Us",
      p2: "Once this account is closed, all your data will be deleted. You won't be able to use it or reopen it, but you can sign up again to open a new account",
      rc: "Reason for Closure",
      min8: "Minimum 8 character",
      cc: "Close the account",
      q: "Do you really want to permanently close your SPW account?",
    },
    gcb: {
      nocarte: "No card registered",
      title: "You must register a card when making a payment with a credit card",
      ac: "Activate card",
      dc: "Deactivate card",
      sc: "Delete card",
    },
    popst: {
      title: "CONGRATULATION !",
      title2: "New Loyalty Status",
      title3: "SPW offers you gift points",
      title4: "We thank you for your loyalty",
    },
    tw: {
      tw: "Money Transfer to SPW Wallet",
      tnv: "Transfer Again",
      mpin: "Change PIN",
      confpin: "Confirm the operation with your PIN",
    },
    docBank: {
      title: "Bank Transfer",
      d1: "With the Bank Transfer service, you can request to transfer your balance from the SPW platform to your verified bank account.",
      d2: "What is a verified bank account?",
      d3: "It is a bank account that meets the following conditions:",
      d4: "The bank account must have the same name as your SPW account, or your request will be rejected.",
      d5: "Before confirming your first transfer, you must send us the file of your bank ID or bank statement containing a clear and readable RIB.",
      d6: 'Who is the "transfer to bank account" service for?',
      d7: "All verified users on the SPW.tn platform",
      d8: "Add account",
      d9: 'Click on the "+" button.',
      d10: "Fill out the addition form.",
      d11: "Upload the file of your bank ID or bank statement.",
      d12: "Click validate to send your addition request.",
      d13: "How to make a transfer to a bank account?",
      d14: 'All registered and verified users on SPW.tn can, from the "Bank Transfer" section, make a balance transfer from their SPW account to their bank account. Just follow the steps below:',
      d15: "Enter the amount to transfer in DT (Minimum 20 DT and Maximum 3000 DT)",
      d16: "Enter the RIB (a series of 20 digits).",
      d17: "Select the bank that corresponds to the RIB.",
      d18: 'Confirm the transfer by clicking "Send."',
      d19: "The processing of your request takes a few days.",
      d20: "You can make a bank transfer only if your SPW balance is equal to or greater than the amount to be paid (amount with commission).",
      d21: "If you have a bank transfer request in process, you cannot send another transfer request.",
      d22: "How much does it cost?",
      d23: "The commission for this service is 2DT.",
      d24: "The advantages of an online bank transfer on SPW:",
      d25: "Withdraw your SPW balance from your agency or bank card",
      d26: "Benefit from a secure, instant, and accessible online transfer at any time (24/7)",
    },
    docM: {
      title: "Merchant Payment",
      d1: "What is merchant payment?",
      d2: "Online payment service is a set of dematerialized operations made available to SPW.tn users, allowing them to settle purchases made on a partner electronic commerce site of SPW. This payment is made through the SPW account securely.",
      d3: "Service Operation:",
      d4: "After validating your cart on the merchant's website and choosing the SPW payment method, you can pay using the two methods below:",
      d41: "1st method:",
      d5: "You will fill out a form by entering information such as your email, password, or your phone number associated with your SPW account. You will then be redirected to the payment validation form to choose the method with which you want to pay: national or international bank card, e-DINAR card from the post office, or using your SPW balance.",
      d42: "2nd method:",
      d6: "Each merchant payment transaction is identified by a payment code, and each merchant is identified by a merchant code that you can use when validating the payment by accessing your SPW account in the merchant payment section.",
      d7: "Once the payment is validated, you cannot cancel the transaction.",
      d8: "The merchant payment is validated instantly, and the delivery process is activated immediately.",
      d9: 'If you have lost the payment code, you can recover it from the "merchant payment" transaction history.',
      d10: "The payment code remains valid for only 60 minutes. Beyond this time, the user cannot pay with this code and must place another order on the merchant's website.",
      d43: "Payment Execution:",
      d11: "The amounts to be paid mentioned on the merchant's site are in Tunisian Dinar (DT) inclusive of all taxes and are valid at the time of consultation by the customer. The payment will be processed immediately by the system. In case of unavailability, you will be informed, and your payment will not be processed. You can retry the payment later.",
      d44: "Payment:",
      d12: "To make a payment, you must choose SPW as the payment method by clicking on the designated button. Your payment through the SPW service is managed by the company HAMTEL, which provides a fully secure payment service. You guarantee to SPW that you have the necessary permissions to use the chosen payment method when validating your payment request. You declare that you are the legitimate holder of the SPW account used for online payment and assume all consequences in case of a contrary situation.",
      d13: "User Protection and Rights:",
      d14: "Delivery Time:",
      d15: "The seller or the merchant's site must deliver the goods or provide the service on the date specified in the order. If no date was set during the order, the delivery of the goods or the execution of the service must occur no later than 1 month after the order.",
      d16: "In case of non-compliance with the delivery time, you can cancel your order by sending a request from your SPW account.",
      d17: "Refund Time:",
      d18: "If you return the goods to the SPW partner merchant or cancel the service after canceling your order due to non-compliance with the delivery time or if the product you purchased from the merchant's site is not in conformity after delivery:",
      d19: "It is unfit for the usual expected use of a similar item.",
      d20: "It does not match the description given by the seller (for example, the color does not match the model presented).",
      d21: "It does not have the qualities advertised by the seller (for example, a device presented as particularly quiet that turns out to be noisy).",
      d22: "You must be refunded within a maximum of 1 month. However, the merchant may delay the refund until the day of recovery of the goods or until you have provided proof of shipment of the goods.",
      d23: "The merchant must refund you the full amount you paid, including delivery costs.",
      d24: "In case of non-compliance with the delivery time, you can cancel your order by sending a request from your SPW account.",
      d25: "Bonus Right:",
      d26: "Each user will have a bonus on purchases made from SPW partner merchants. It is a percentage deducted from the purchase transaction amount and added to the user's bonus balance:",
      d27: "The bonus granted to the buyer is not fixed and depends on the merchant or service on SPW and will be displayed before the execution of each payment.",
      d28: "The SPW partner merchant may not grant bonuses to buyers for some or all of the items or services offered in their shop.",
      d29: "Validation of payment by the user means the acceptance of the price and bonus related to the item or service offered by the merchant or by SPW.",
      d30: "The SPW customer can only use the bonus and transfer it to the SPW balance if the bonus balance exceeds 5 Tunisian Dinars (5DT).",
      d31: "You can transfer your bonus balance only to your SPW balance.",
      d32: "If the payment has been canceled or the customer has been refunded, the bonus amount related to the canceled transaction will be deducted from the customer's bonus balance.",
      d33: "If the bonus balance is less than the amount of the bonus related to the canceled transaction, the latter will be deducted from the total or partial amount of the canceled transaction before the customer is refunded.",
      d34: "Advantages of merchant payment through SPW:",
      d35: "You can pay any physical or virtual merchant partner of SPW.",
      d36: "You always receive a bonus after each merchant payment.",
      d37: "Highly secure and instant service.",
      d38: "Immediate refund in case of an issue.",
      d39: "SPW protects its users from scam issues or non-compliance with delivery times for all online payments made with their SPW accounts.",
      d40: "An easy-to-use solution that is accessible at all times (24/7).",
    },
    pays: {
      Ariana: "Ariana",
      Beja: "Beja",
      BenArous: "Ben Arous",
      Bizerte: "Bizerte",
      Gabes: "Gabes",
      Gafsa: "Gafsa",
      Jendouba: "Jendouba",
      Kairouan: "Kairouan",
      Kasserine: "Kasserine",
      Kebili: "Kebili",
      Kef: "Kef",
      Mahdia: "Mahdia",
      Manouba: "Manouba",
      Medenine: "Medenine",
      Monastir: "Monastir",
      Nabeul: "Nabeul",
      Sfax: "Sfax",
      SidiBouzid: "Sidi Bouzid",
      Siliana: "Siliana",
      Sousse: "Sousse",
      Tataouine: "Tataouine",
      Tozeur: "Tozeur",
      Tunis: "Tunis",
      Zaghouan: "Zaghouan",
      Autre: "Autre",
      tt: "All cities",
      t: "All",
    },
    listserv: {
      title: "The services offered by the",
      t2: "shop",
      des: "To purchase, click on the desired service and follow the purchasing process with the SPW payment method.",
    },
  },
};
